import { defineComponent as n, useAttrs as g, computed as i, ref as w, provide as y, createBlock as k, openBlock as M, unref as d, mergeProps as S, withCtx as x, renderSlot as O } from "vue";
import { JSONtoNaiveVars as q } from "./highrise343.mjs";
import { validateFormSize as N } from "./highrise344.mjs";
import { COMPONENT_NAME as z } from "./highrise178.mjs";
import B from "./highrise345.mjs";
const F = n({
  name: z.FORM
}), I = /* @__PURE__ */ n({
  ...F,
  props: {
    size: {
      type: String,
      default: "md",
      validator: N
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    inline: {
      type: Boolean,
      default: void 0
    },
    labelWidth: {
      type: [String, Number],
      default: void 0
    },
    labelAlign: {
      type: String,
      default: void 0
    },
    labelPlacement: {
      type: String,
      default: void 0
    },
    model: {
      type: Object,
      default: void 0
    },
    rules: {
      type: Object,
      default: void 0
    },
    showFeedback: {
      type: Boolean,
      default: void 0
    },
    showLabel: {
      type: Boolean,
      default: void 0
    },
    showRequireMark: {
      type: Boolean,
      default: void 0
    },
    requireMarkPlacement: {
      type: String,
      default: void 0
    },
    validateMessages: {
      type: Object,
      default: void 0
    }
  },
  setup(e, { expose: m }) {
    const r = e, o = g(), u = {
      sm: "6px",
      md: "8px",
      lg: "11px"
    }, f = {
      lg: "xs",
      md: "2xs",
      sm: "3xs"
    }, c = i(
      () => q({
        formItemGap: u[r.size]
      })
    ), v = i(() => ({
      [`hr-form-${r.size}`]: !0
    })), l = w();
    function b() {
      return l.value;
    }
    const h = Object.keys(o).reduce(
      (t, a) => ((a === "class" || a.startsWith("data-")) && (t[a] = o[a]), t),
      {}
    );
    m({
      getForm: b,
      validate: (t, a) => {
        var s;
        return (s = l.value) == null ? void 0 : s.validate(t, a);
      },
      formRef: l,
      restoreValidation: () => {
        var t;
        return (t = l.value) == null ? void 0 : t.restoreValidation();
      }
    });
    const p = i(() => f[r.size]);
    return y("hr-form", p.value), (t, a) => (M(), k(d(B), S({ ...d(h) }, {
      ref_key: "formRef",
      ref: l,
      disabled: e.disabled,
      inline: e.inline,
      "label-width": e.labelWidth,
      "label-align": e.labelAlign,
      "label-placement": e.labelPlacement,
      model: e.model,
      rules: e.rules,
      "show-feedback": e.showFeedback,
      "show-label": e.showLabel,
      "show-require-mark": e.showRequireMark,
      "require-mark-placement": e.requireMarkPlacement,
      "validate-messages": e.validateMessages,
      style: c.value,
      class: v.value
    }), {
      default: x(() => [
        O(t.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 16, ["disabled", "inline", "label-width", "label-align", "label-placement", "model", "rules", "show-feedback", "show-label", "show-require-mark", "require-mark-placement", "validate-messages", "style", "class"]));
  }
});
export {
  I as default
};
